var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "index_wrap",
      staticStyle: { height: "calc(90%)", position: "relative" }
    },
    [
      _c(
        "div",
        {
          staticClass: "ShowHeader",
          class: _vm.topType ? "headerTop" : "hindDown"
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.avtive == 0,
                  expression: "avtive == 0"
                }
              ],
              staticClass: "changeConter",
              staticStyle: { width: "910px" }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.Sonindex == 0 || _vm.Sonindex == 2,
                      expression: "Sonindex == 0 || Sonindex == 2"
                    }
                  ],
                  staticClass: "HYsouch"
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "100%",
                        "box-sizing": "border-box",
                        float: "left"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "selectWrap",
                          staticStyle: { width: "50%" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "Mostyle",
                              staticStyle: { float: "left", width: "100%" },
                              attrs: {
                                "suffix-icon": "el-icon-date",
                                filterable: "",
                                placeholder: _vm.$t(
                                  "i18n_Please_choose_original_wareohuse"
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.changeCk(_vm.pollandId)
                                }
                              },
                              model: {
                                value: _vm.pollandId,
                                callback: function($$v) {
                                  _vm.pollandId = $$v
                                },
                                expression: "pollandId"
                              }
                            },
                            [
                              _vm.Sonindex == 0
                                ? _vm._l(_vm.LCLWarehouseList, function(item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.namec,
                                        value: item.id
                                      }
                                    })
                                  })
                                : _vm._l(_vm.KYWarehouseList, function(item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.namec,
                                        value: item.id
                                      }
                                    })
                                  }),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "el-input__icon el-icon-s-home",
                                staticStyle: {
                                  "font-size": "28px",
                                  "margin-top": "5px",
                                  "margin-left": "10px"
                                },
                                attrs: { slot: "prefix" },
                                slot: "prefix"
                              })
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "50%",
                            padding: "0 1px",
                            "box-sizing": "border-box",
                            float: "left",
                            "border-left": "1px solid #eeeeee"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "select2",
                              staticStyle: { float: "left", width: "100%" }
                            },
                            [
                              _vm._m(0),
                              _vm._v(" "),
                              _c("el-cascader", {
                                ref: "refshouname",
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "i18n_please_choose_your_destination"
                                  ),
                                  options: _vm.WarehouseList,
                                  props: _vm.defaultParams
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.changeECk(_vm.WarehousItemID)
                                  }
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var node = ref.node
                                      var data = ref.data
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(data.namec))
                                        ]),
                                        _vm._v(" "),
                                        !node.isLeaf ? _c("span") : _vm._e()
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.WarehousItemID,
                                  callback: function($$v) {
                                    _vm.WarehousItemID = $$v
                                  },
                                  expression: "WarehousItemID"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.Sonindex == 3,
                      expression: "Sonindex == 3"
                    }
                  ],
                  staticClass: "FBAsouch"
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "100%",
                        "box-sizing": "border-box",
                        float: "left"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "selectWrap",
                          staticStyle: {
                            width: "50%",
                            float: "left",
                            position: "relative"
                          }
                        },
                        [
                          _vm._m(1),
                          _vm._v(" "),
                          _c(
                            "el-cascader",
                            {
                              key: _vm.cascaderKey,
                              ref: "changefromFABck",
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "i18n_Please_choose_original_wareohuse"
                                ),
                                options: _vm.FBAfromCk,
                                props: _vm.FBAdataprops
                              },
                              on: {
                                change: function($event) {
                                  return _vm.changefromFABck(_vm.thatALLcklist)
                                }
                              },
                              model: {
                                value: _vm.thatALLcklist,
                                callback: function($$v) {
                                  _vm.thatALLcklist = $$v
                                },
                                expression: "thatALLcklist"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-input__icon el-icon-s-home",
                                staticStyle: {
                                  "font-size": "28px",
                                  "margin-top": "5px",
                                  "margin-left": "10px"
                                },
                                attrs: { slot: "prefix" },
                                slot: "prefix"
                              })
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "50%",
                            padding: "0 1px",
                            "box-sizing": "border-box",
                            float: "left",
                            "border-left": "1px solid #eeeeee"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "select2",
                              staticStyle: { float: "left", width: "100%" }
                            },
                            [
                              _vm._m(2),
                              _vm._v(" "),
                              _c("el-cascader", {
                                ref: "changetoFABck",
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "i18n_please_choose_your_destination"
                                  ),
                                  options: _vm.FBAtoCk,
                                  props: _vm.toFBAdataprops
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.changetoFABck(_vm.thatFBAcklist)
                                  }
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var node = ref.node
                                      var data = ref.data
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(data.namec))
                                        ]),
                                        _vm._v(" "),
                                        !node.isLeaf ? _c("span") : _vm._e()
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.thatFBAcklist,
                                  callback: function($$v) {
                                    _vm.thatFBAcklist = $$v
                                  },
                                  expression: "thatFBAcklist"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.Sonindex == 1,
                      expression: "Sonindex == 1"
                    }
                  ],
                  staticClass: "FBAsouch"
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "100%",
                        "box-sizing": "border-box",
                        float: "left"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "selectWrap",
                          staticStyle: { width: "50%", float: "left" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("i18n_please_choose")
                              },
                              on: { change: _vm.onFclSelectChange },
                              model: {
                                value: _vm.fclRequestParams.pol,
                                callback: function($$v) {
                                  _vm.$set(_vm.fclRequestParams, "pol", $$v)
                                },
                                expression: "fclRequestParams.pol"
                              }
                            },
                            _vm._l(_vm.startPorts, function(item, index) {
                              return _c(
                                "el-option",
                                {
                                  key: index,
                                  attrs: {
                                    label: item.enName + " " + item.cnName,
                                    value: item.code
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "space-between"
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            item.enName + " " + item.cnName
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s("" + item.country) +
                                            " " +
                                            _vm._s(item.city || "")
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "50%",
                            padding: "0 1px",
                            "box-sizing": "border-box",
                            float: "left",
                            "border-left": "1px solid #eeeeee"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "select2",
                              staticStyle: { float: "left", width: "100%" }
                            },
                            [
                              _vm._m(3),
                              _vm._v(" "),
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t("i18n_please_choose")
                                  },
                                  on: { change: _vm.onFclSelectChange },
                                  model: {
                                    value: _vm.fclRequestParams.pod,
                                    callback: function($$v) {
                                      _vm.$set(_vm.fclRequestParams, "pod", $$v)
                                    },
                                    expression: "fclRequestParams.pod"
                                  }
                                },
                                _vm._l(_vm.endPorts, function(item, index) {
                                  return _c(
                                    "el-option",
                                    {
                                      key: index,
                                      attrs: {
                                        label: item.enName + " " + item.cnName,
                                        value: item.code
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "space-between"
                                          }
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                item.enName + " " + item.cnName
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s("" + item.country) +
                                                " " +
                                                _vm._s(item.city || "")
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.avtive == 1,
                  expression: "avtive == 1"
                }
              ],
              staticClass: "changeConter searchWrap",
              staticStyle: { width: "930px" }
            },
            [
              _c("el-input", {
                staticStyle: { width: "100%", height: "53px" },
                attrs: {
                  placeholder: _vm.$t(
                    "i18n_Please_enter_the_order_number_to_inquire"
                  )
                },
                model: {
                  value: _vm.inos,
                  callback: function($$v) {
                    _vm.inos = $$v
                  },
                  expression: "inos"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.avtive == 0,
                  expression: "avtive == 0"
                }
              ]
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: {
                    width: "160px",
                    background: "#fff157",
                    border: "1px solid #fff157",
                    color: "#5ab53c",
                    height: "53px",
                    "font-size": "18px",
                    "font-weight": "500",
                    "border-radius": "10px"
                  },
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: { click: _vm.getFiledata }
                },
                [_vm._v(_vm._s(_vm.$t("i18n_Inquiry")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.avtive == 1,
                  expression: "avtive == 1"
                }
              ]
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: {
                    width: "160px",
                    background: "#fff157",
                    border: "1px solid #fff157",
                    color: "#5ab53c",
                    height: "53px",
                    "font-size": "18px",
                    "font-weight": "500",
                    "border-radius": "10px"
                  },
                  attrs: {
                    loading: _vm.trackLoading,
                    type: "primary",
                    icon: "el-icon-search"
                  },
                  on: { click: _vm.Searchgj }
                },
                [_vm._v(_vm._s(_vm.$t("i18n_Inquiry")))]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          class: _vm.topType ? "hindDown" : "headerTop",
          staticStyle: {
            float: "left",
            "text-align": "center",
            width: "100%",
            "font-size": "48px",
            "font-family": "PingFang SC",
            "font-weight": "800",
            color: "#ffffff",
            "text-shadow": "0px 0px 39px rgba(31, 24, 78, 0.15)",
            "margin-top": "5%"
          }
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("i18n_Index_title")) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          class: _vm.topType ? "hindDown" : "headerTop",
          staticStyle: {
            float: "left",
            "text-align": "center",
            width: "100%",
            "font-size": "32px",
            "font-family": "PingFang SC",
            "letter-spacing": "4px",
            color: "#ffffff",
            "text-shadow": "0px 0px 39px rgba(31, 24, 78, 0.15)",
            "margin-top": "10px"
          }
        },
        [_vm._v(_vm._s(_vm.$t("i18n_Index_title_l")))]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "nav_count" }, [
        _c("div", {}, [
          _c("div", { class: _vm.topType ? "hindDown" : "showTop " }, [
            _c("div", { staticClass: "navlist" }, [
              _c(
                "ul",
                _vm._l(_vm.navLIst, function(item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "oldnavcalss",
                      class: _vm.avtive == index ? "navStyle" : "",
                      on: {
                        click: function($event) {
                          return _vm.changeNav(index)
                        }
                      }
                    },
                    [
                      _c("span", { staticStyle: { opacity: "1" } }, [
                        _vm._v(_vm._s(_vm.$t(item.name)))
                      ])
                    ]
                  )
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "count_text" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.avtive == 0,
                      expression: "avtive == 0"
                    }
                  ],
                  staticClass: "navCountshow"
                },
                [
                  _c("div", { staticStyle: { width: "100%", float: "left" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "typeNAv",
                        staticStyle: {
                          "margin-bottom": "35px",
                          width: "100%",
                          float: "left"
                        }
                      },
                      _vm._l(_vm.Typelist, function(item) {
                        return _c(
                          "div",
                          {
                            key: item.index,
                            staticClass: "navItem",
                            class:
                              _vm.Sonindex == item.index ? "activesonty" : "",
                            on: {
                              click: function($event) {
                                return _vm.changesonNav(item.index)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center"
                                }
                              },
                              [
                                _c("img", {
                                  staticStyle: { "margin-right": "5px" },
                                  attrs: {
                                    src:
                                      _vm.Sonindex == item.index
                                        ? item.url2
                                        : item.url1,
                                    alt: ""
                                  }
                                }),
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.$t(item.name)) +
                                    "\n                    "
                                ),
                                _c("span", {
                                  staticClass: "navson",
                                  class:
                                    _vm.Sonindex == item.index
                                      ? "activesonty2"
                                      : ""
                                })
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.Sonindex == 0 || _vm.Sonindex == 2,
                          expression: "Sonindex == 0 || Sonindex == 2"
                        }
                      ],
                      staticClass: "SHtext"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "wrap_s",
                          staticStyle: {
                            width: "100%",
                            "margin-bottom": "16px"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c("el-col", { attrs: { span: 10 } }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "100%",
                                      padding: "0 1px",
                                      "box-sizing": "border-box",
                                      float: "left"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "selectWrap" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "selectIcon" },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-s-home"
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-select",
                                          {
                                            staticClass: "Mostyle",
                                            staticStyle: {
                                              float: "left",
                                              width: "100%"
                                            },
                                            attrs: {
                                              filterable: "",
                                              placeholder: _vm.$t(
                                                "i18n_Please_choose_original_wareohuse"
                                              )
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.changeCk(
                                                  _vm.pollandId
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.pollandId,
                                              callback: function($$v) {
                                                _vm.pollandId = $$v
                                              },
                                              expression: "pollandId"
                                            }
                                          },
                                          [
                                            _vm.Sonindex == 0
                                              ? _vm._l(
                                                  _vm.LCLWarehouseList,
                                                  function(item) {
                                                    return _c("el-option", {
                                                      key: item.id,
                                                      attrs: {
                                                        label: item.namec,
                                                        value: item.id
                                                      }
                                                    })
                                                  }
                                                )
                                              : _vm._l(
                                                  _vm.KYWarehouseList,
                                                  function(item) {
                                                    return _c("el-option", {
                                                      key: item.id,
                                                      attrs: {
                                                        label: item.namec,
                                                        value: item.id
                                                      }
                                                    })
                                                  }
                                                )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 10 } }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "100%",
                                      padding: "0 1px",
                                      "box-sizing": "border-box",
                                      float: "left"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "select2",
                                        staticStyle: {
                                          float: "left",
                                          width: "100%"
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "selectIcon2" },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-map-location"
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("el-cascader", {
                                          ref: "refshouname",
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "i18n_please_choose_your_destination"
                                            ),
                                            options: _vm.WarehouseList,
                                            props: _vm.defaultParams
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.changeECk(
                                                _vm.WarehousItemID
                                              )
                                            }
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.getWarehouse($event)
                                            }
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var node = ref.node
                                                var data = ref.data
                                                return [
                                                  _c("span", [
                                                    _vm._v(_vm._s(data.namec))
                                                  ]),
                                                  _vm._v(" "),
                                                  !node.isLeaf
                                                    ? _c("span")
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ]),
                                          model: {
                                            value: _vm.WarehousItemID,
                                            callback: function($$v) {
                                              _vm.WarehousItemID = $$v
                                            },
                                            expression: "WarehousItemID"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 4 } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: {
                                        width: "160px",
                                        "border-radius": "10px"
                                      },
                                      attrs: {
                                        type: "primary",
                                        icon: "el-icon-search"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.getFiledata()
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("i18n_Inquiry")))]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.Sonindex == 3,
                          expression: "Sonindex == 3"
                        }
                      ],
                      staticClass: "FBAtext"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "wrap_s",
                          staticStyle: {
                            width: "100%",
                            "margin-bottom": "16px"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c("el-col", { attrs: { span: 10 } }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "100%",
                                      padding: "0 1px",
                                      "box-sizing": "border-box",
                                      float: "left"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "selectWrap" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "selectIcon" },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-s-home"
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("el-cascader", {
                                          ref: "changefromFABck",
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "i18n_Please_choose_original_wareohuse"
                                            ),
                                            options: _vm.FBAfromCk,
                                            props: _vm.FBAdataprops
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.changefromFABck(
                                                _vm.thatALLcklist
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.thatALLcklist,
                                            callback: function($$v) {
                                              _vm.thatALLcklist = $$v
                                            },
                                            expression: "thatALLcklist"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 10 } }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "border-radius": "4px",
                                      width: "100%",
                                      padding: "0 1px",
                                      "box-sizing": "border-box",
                                      float: "left"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "select2",
                                        staticStyle: {
                                          float: "left",
                                          width: "100%"
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "selectIcon2" },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-map-location"
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("el-cascader", {
                                          ref: "changetoFABck",
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "i18n_please_choose_your_destination"
                                            ),
                                            options: _vm.FBAtoCk,
                                            props: _vm.toFBAdataprops
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.changetoFABck(
                                                _vm.thatFBAcklist
                                              )
                                            }
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var node = ref.node
                                                var data = ref.data
                                                return [
                                                  _c("span", [
                                                    _vm._v(_vm._s(data.namec))
                                                  ]),
                                                  _vm._v(" "),
                                                  !node.isLeaf
                                                    ? _c("span")
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ]),
                                          model: {
                                            value: _vm.thatFBAcklist,
                                            callback: function($$v) {
                                              _vm.thatFBAcklist = $$v
                                            },
                                            expression: "thatFBAcklist"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 4 } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: {
                                        width: "160px",
                                        "border-radius": "10px"
                                      },
                                      attrs: {
                                        type: "primary",
                                        icon: "el-icon-search"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.getFiledata()
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("i18n_Inquiry")))]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.Sonindex == 1,
                          expression: "Sonindex == 1"
                        }
                      ],
                      staticClass: "FBAtext"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "wrap_s",
                          staticStyle: {
                            width: "100%",
                            "margin-bottom": "16px"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c("el-col", { attrs: { span: 10 } }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "100%",
                                      padding: "0 1px",
                                      "box-sizing": "border-box",
                                      float: "left"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "selectWrap" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "selectIcon" },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-s-home"
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              placeholder: _vm.$t(
                                                "i18n_please_choose"
                                              )
                                            },
                                            model: {
                                              value: _vm.fclRequestParams.pol,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.fclRequestParams,
                                                  "pol",
                                                  $$v
                                                )
                                              },
                                              expression: "fclRequestParams.pol"
                                            }
                                          },
                                          _vm._l(_vm.startPorts, function(
                                            item,
                                            index
                                          ) {
                                            return _c(
                                              "el-option",
                                              {
                                                key: index,
                                                attrs: {
                                                  label:
                                                    item.enName +
                                                    " " +
                                                    item.cnName,
                                                  value: item.code
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      "justify-content":
                                                        "space-between"
                                                    }
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.enName +
                                                            " " +
                                                            item.cnName
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          "" + item.country
                                                        ) +
                                                          "\n                                " +
                                                          _vm._s(
                                                            item.city || ""
                                                          )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          }),
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 10 } }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "border-radius": "4px",
                                      width: "100%",
                                      padding: "0 1px",
                                      "box-sizing": "border-box",
                                      float: "left"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "select2",
                                        staticStyle: {
                                          float: "left",
                                          width: "100%"
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "selectIcon2" },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-map-location"
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              placeholder: _vm.$t(
                                                "i18n_please_choose"
                                              )
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.fclChange()
                                              }
                                            },
                                            model: {
                                              value: _vm.fclRequestParams.pod,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.fclRequestParams,
                                                  "pod",
                                                  $$v
                                                )
                                              },
                                              expression: "fclRequestParams.pod"
                                            }
                                          },
                                          _vm._l(_vm.endPorts, function(
                                            item,
                                            index
                                          ) {
                                            return _c(
                                              "el-option",
                                              {
                                                key: index,
                                                attrs: {
                                                  label:
                                                    item.enName +
                                                    " " +
                                                    item.cnName,
                                                  value: item.code
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      "justify-content":
                                                        "space-between"
                                                    }
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.enName +
                                                            " " +
                                                            item.cnName
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          "" + item.country
                                                        ) +
                                                          "\n                                " +
                                                          _vm._s(
                                                            item.city || ""
                                                          )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          }),
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 4 } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: {
                                        width: "160px",
                                        "border-radius": "10px"
                                      },
                                      attrs: {
                                        type: "primary",
                                        icon: "el-icon-search"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.getFiledata()
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("i18n_Inquiry")))]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.avtive == 1,
                      expression: "avtive == 1"
                    }
                  ],
                  staticClass: "Guiji"
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 20 } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%", height: "53px" },
                            attrs: {
                              placeholder: _vm.$t(
                                "i18n_Please_enter_the_order_number_to_inquire"
                              )
                            },
                            model: {
                              value: _vm.inos,
                              callback: function($$v) {
                                _vm.inos = $$v
                              },
                              expression: "inos"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "el-icon-search",
                              staticStyle: {
                                width: "100%",
                                height: "53px",
                                "font-size": "18px",
                                "border-radius": "10px"
                              },
                              attrs: {
                                loading: _vm.trackLoading,
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.Searchgj()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("i18n_Inquiry")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "show_count",
          class: _vm.topType ? "showbgColor showDown" : "showTop"
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.avtive == 0,
                  expression: "avtive == 0"
                }
              ],
              staticStyle: { width: "100%", height: "100%" }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.lableData.length,
                      expression: "lableData.length"
                    }
                  ],
                  staticClass: "huowuData"
                },
                [
                  false
                    ? _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.Sonindex == 1 || _vm.Sonindex == 3,
                              expression: "Sonindex == 1 || Sonindex == 3"
                            }
                          ],
                          staticClass: "card_wrap",
                          staticStyle: { padding: "30px" }
                        },
                        [
                          _c("div", [
                            _c(
                              "span",
                              { staticStyle: { "font-weight": "600" } },
                              [
                                _vm._v(
                                  "如需要“门到门”相关服务，请勾选以下选项："
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { "margin-top": "20px" } },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "border-bottom": "1px solid #eee",
                                      "padding-bottom": "30px",
                                      "margin-bottom": "30px"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "align-items": "center"
                                        }
                                      },
                                      [
                                        _c("el-checkbox", {
                                          model: {
                                            value: _vm.checked1,
                                            callback: function($$v) {
                                              _vm.checked1 = $$v
                                            },
                                            expression: "checked1"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "10px",
                                              "font-size": "18px",
                                              "font-family": "PingFang SC",
                                              "font-weight": "500",
                                              color: "#333333"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    起运地 上门提货"
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.checked1,
                                            expression: "checked1"
                                          }
                                        ],
                                        staticClass:
                                          "animate__animated animate__fadeIn",
                                        staticStyle: {
                                          display: "flex",
                                          "align-items": "center",
                                          "margin-top": "20px"
                                        }
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("i18n_pickup_location")
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-left": "10px",
                                              color: "#999",
                                              border: "1px solid #eee",
                                              padding: "8px",
                                              width: "30%",
                                              cursor: "pointer",
                                              "border-radius": "5px",
                                              display: "flex",
                                              "align-items": "center",
                                              "justify-content": "space-between"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.showDialogOfMine()
                                              }
                                            }
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.countLIst_T.parvince
                                                    ? _vm.countLIst_T.parvince +
                                                        " " +
                                                        _vm.countLIst_T.city +
                                                        " " +
                                                        _vm.countLIst_T.area +
                                                        " " +
                                                        _vm.countLIst_T.address
                                                    : "请选择提货地点"
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("i", {
                                              staticClass: "el-icon-arrow-right"
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.Sonindex == 1 ||
                                          _vm.Sonindex == 3,
                                        expression:
                                          "Sonindex == 1 || Sonindex == 3"
                                      }
                                    ],
                                    staticStyle: { "margin-top": "20px" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { "margin-bottom": "0px" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "align-items": "center"
                                            }
                                          },
                                          [
                                            _c("el-checkbox", {
                                              model: {
                                                value: _vm.checked2,
                                                callback: function($$v) {
                                                  _vm.checked2 = $$v
                                                },
                                                expression: "checked2"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-left": "10px",
                                                  "font-size": "18px",
                                                  "font-family": "PingFang SC",
                                                  "font-weight": "500",
                                                  color: "#333333"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      目的地 送货上门"
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.checked2,
                                                expression: "checked2"
                                              }
                                            ],
                                            staticClass:
                                              "animate__animated animate__fadeIn",
                                            staticStyle: {
                                              display: "flex",
                                              "align-items": "center",
                                              "margin-top": "20px"
                                            }
                                          },
                                          [
                                            _c("span", [_vm._v("派送地点")]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "margin-left": "10px",
                                                  color: "#999",
                                                  border: "1px solid #eee",
                                                  padding: "8px",
                                                  width: "30%",
                                                  cursor: "pointer",
                                                  "border-radius": "5px",
                                                  display: "flex",
                                                  "align-items": "center",
                                                  "justify-content":
                                                    "space-between"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.showDialogOfMine(
                                                      "PS"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.countLIst_C.country
                                                        ? _vm.countLIst_C
                                                            .country +
                                                            " " +
                                                            _vm.countLIst_C
                                                              .city +
                                                            " " +
                                                            _vm.countLIst_C
                                                              .area +
                                                            " " +
                                                            _vm.countLIst_C
                                                              .address
                                                        : "请选择派送地点"
                                                    ) +
                                                      "\n                      "
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-arrow-right"
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.checked1 || _vm.checked2
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "redBtn",
                                        on: {
                                          click: function($event) {
                                            return _vm.goQuery()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                进一步查价\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.lableData, function(item, index) {
                    return _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isSelected,
                            expression: "isSelected"
                          }
                        ],
                        key: index,
                        staticClass: "card_wrap",
                        class: _vm.topType
                          ? "animate__animated animate__lightSpeedInRight"
                          : ""
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "wrap_l",
                            staticStyle: { float: "left", width: "80%" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "count_Top",
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "LR_center",
                                    staticStyle: { float: "left" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "font-size": "28px",
                                          "font-family": "PingFang SC",
                                          "font-weight": "bold",
                                          color: "#343434"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(item.goodstype) +
                                            _vm._s(item.transportTypeName) +
                                            "\n                  "
                                        ),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              item.productName
                                                ? item.productName
                                                : ""
                                            ) +
                                            "\n                  "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "min-width": "100px",
                                          "min-height": "30px",
                                          background: "#ffffff",
                                          border: "1px solid #5ab53c",
                                          "border-radius": "17px",
                                          "text-align": "center",
                                          display: "flex",
                                          "align-items": "center",
                                          "justify-content": "center",
                                          "line-height": "1",
                                          "margin-top": "4px",
                                          "margin-left": "30px",
                                          color: "#5ab53c",
                                          cursor: "pointer"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.showText(item)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "i18n_Shipping_Instructions"
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      float: "left",
                                      "margin-left": "40px",
                                      display: "flex",
                                      "align-items": "center",
                                      "justify-content": "center"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "fontTyle",
                                        staticStyle: { float: "left" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.cangkuShow.namec) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          width: "155px",
                                          float: "left",
                                          display: "flex",
                                          "flex-direction": "column",
                                          "align-items": "center",
                                          "justify-content": "center"
                                        }
                                      },
                                      [
                                        item.prescriptionAdditionalRemark !==
                                          null && _vm.Sonindex === 3
                                          ? _c(
                                              "span",
                                              { staticStyle: { color: "red" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.prescriptionAdditionalRemark
                                                  ) +
                                                    _vm._s(
                                                      item.prescriptionbegin
                                                    ) +
                                                    "-" +
                                                    _vm._s(
                                                      item.prescriptionend
                                                    ) +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "i18n_natural_days"
                                                      )
                                                    )
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.productId == "85131913000"
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "red",
                                                  "max-width": "120px",
                                                  "padding-bottom": "5px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "i18n_minimum_20kg"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.productId == "85332194000"
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "red",
                                                  "max-width": "120px",
                                                  "padding-bottom": "5px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "i18n_minimum_150kg"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.prescriptionAdditionalRemark ==
                                        null
                                          ? _c(
                                              "span",
                                              {
                                                style: {
                                                  color:
                                                    item.productId ==
                                                    "85131913000"
                                                      ? "red"
                                                      : item.productId ==
                                                        "85332194000"
                                                      ? "red"
                                                      : "#9a9a9a"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.prescriptionbegin
                                                  ) +
                                                    "-" +
                                                    _vm._s(
                                                      item.prescriptionend
                                                    ) +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "i18n_natural_days"
                                                      )
                                                    )
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "jiantou" }),
                                        _vm._v(" "),
                                        item.productId == "85131913000"
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "red",
                                                  "max-width": "155px",
                                                  "padding-top": "5px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "i18n_non_electrified_flight"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.productId == "85131913000"
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "red",
                                                  "max-width": "155px",
                                                  "padding-top": "5px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "i18n_domestic_flights"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.productId == "85332194000"
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "red",
                                                  "max-width": "155px",
                                                  "padding-top": "5px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "i18n_non_electrified_flight"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.productId == "85332194000"
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "red",
                                                  "max-width": "155px",
                                                  "padding-top": "5px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "i18n_domestic_flights"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm._t("reference"),
                                        _vm._v(" "),
                                        item.prescriptionAdditionalRemark !==
                                          null && _vm.Sonindex === 3
                                          ? _c(
                                              "el-popover",
                                              {
                                                attrs: {
                                                  placement: "bottom",
                                                  title: "",
                                                  width: "200",
                                                  trigger: "hover"
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "red"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.additionalRemark
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "min-width": "100px",
                                                      "min-height": "30px",
                                                      background: "#ffffff",
                                                      "text-align": "center",
                                                      display: "flex",
                                                      "align-items": "center",
                                                      "justify-content":
                                                        "center",
                                                      "line-height": "1",
                                                      "margin-top": "4px",
                                                      color: "red",
                                                      cursor: "pointer"
                                                    },
                                                    attrs: {
                                                      slot: "reference"
                                                    },
                                                    slot: "reference"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      规则说明\n                    "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "fontTyle",
                                        staticStyle: { float: "left" }
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(_vm.welickShow.namec))
                                        ])
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "textCount",
                                staticStyle: { "margin-top": "20px" }
                              },
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    item.deliveryPriceInfo
                                      ? _c("el-col", { attrs: { span: 5 } }, [
                                          _c(
                                            "div",
                                            { staticClass: "nav_count" },
                                            [
                                              _c("span", {
                                                staticClass: "PSicon"
                                              }),
                                              _vm._v(
                                                " 派送费：" +
                                                  _vm._s(
                                                    item.deliveryPriceInfo
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.pickUpPriceDTO
                                      ? _c("el-col", { attrs: { span: 8 } }, [
                                          _c(
                                            "div",
                                            { staticClass: "nav_count" },
                                            [
                                              _c("span", {
                                                staticClass: "Thicon"
                                              }),
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t("i18n_pickup_fee")
                                                  ) +
                                                  "：" +
                                                  _vm._s(
                                                    item.pickUpPriceDTO
                                                      .priceInfo
                                                  ) +
                                                  "（" +
                                                  _vm._s(
                                                    item.pickUpPriceDTO
                                                      .minKilometer
                                                  ) +
                                                  "-" +
                                                  _vm._s(
                                                    item.pickUpPriceDTO
                                                      .maxKilometer
                                                  ) +
                                                  "KM）\n                  "
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("el-col", { attrs: { span: 10 } }, [
                                      _c("div", [
                                        _c("span", { staticClass: "Djicon" }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("i18n_shipping_cost"))
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "#fe1818",
                                              "font-weight": "bold",
                                              "text-decoration": "underline"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("i18n_from_x_currency", {
                                                  currency: item.currency,
                                                  price: item.priceinfo
                                                })
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "vipIcon" }, [
                                          _vm._v(_vm._s(item.pricedescription))
                                        ])
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    item.deliverPrice
                                      ? _c("el-col", { attrs: { span: 6 } }, [
                                          _c("div", [
                                            _c("span", {
                                              staticClass: "Djicon"
                                            }),
                                            _vm._v(" "),
                                            _c("span", [_vm._v("派送费")]),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#fe1818",
                                                  "font-weight": "bold",
                                                  "text-decoration": "underline"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.deliverPriceCurrency
                                                  ) + _vm._s(item.deliverPrice)
                                                )
                                              ]
                                            )
                                          ])
                                        ])
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "count_Bom" }, [
                              item.label1
                                ? _c("div", { staticClass: "Bom_style" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item.label1) +
                                        "\n              "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.label2
                                ? _c("div", { staticClass: "Bom_style" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item.label2) +
                                        "\n              "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.label3
                                ? _c("div", { staticClass: "Bom_style" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item.label3) +
                                        "\n              "
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "wrap_r",
                            staticStyle: {
                              width: "20%",
                              float: "left",
                              display: "flex",
                              "flex-direction": "column",
                              "align-items": "center",
                              "justify-content": "center",
                              "margin-top": "30px"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "Gotobtn",
                                class:
                                  _vm.activeIndex == index
                                    ? "animate__animated animate__rubberBand"
                                    : "",
                                on: {
                                  click: function($event) {
                                    return _vm.handleClick(item)
                                  },
                                  mouseenter: function($event) {
                                    return _vm.outStyle(index)
                                  },
                                  mouseout: function($event) {
                                    _vm.activeIndex = null
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("i18n_Go_to_Order")) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            item.stepwiseDTOS && _vm.Sonindex != 3
                              ? _c(
                                  "el-popover",
                                  {
                                    attrs: {
                                      placement: "bottom",
                                      width: "430",
                                      trigger: "click"
                                    }
                                  },
                                  [
                                    _vm._l(item.stepwiseDTOS, function(
                                      _item,
                                      _index
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: _index,
                                          staticClass: "LR_center",
                                          staticStyle: {
                                            "border-bottom":
                                              "1px dashed #dcdcdc",
                                            padding: "12px 0"
                                          }
                                        },
                                        [
                                          _c("div", [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#9a9a9a"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_item.stepwise) +
                                                    "(" +
                                                    _vm._s(item.stepwiseUnit) +
                                                    ")"
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "font-size": "13px",
                                                  "font-weight": "bold"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "￥" + _vm._s(_item.priceInfo)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "vipIcon" },
                                              [
                                                _vm._v(
                                                  _vm._s(item.pricedescription)
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          slot: "reference",
                                          type: "text"
                                        },
                                        slot: "reference"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("i18n_Price_Details"))
                                        )
                                      ]
                                    )
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.stepwiseDTOS && _vm.Sonindex == 3
                              ? _c(
                                  "el-popover",
                                  {
                                    attrs: {
                                      placement: "bottom",
                                      width: "530",
                                      trigger: "click"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "FBAtable",
                                        staticStyle: { width: "100%" }
                                      },
                                      [
                                        _vm._l(item.stepwiseDTOS, function(
                                          _item,
                                          _index
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: _index,
                                              staticStyle: {
                                                border: "solid 1px #eee",
                                                "border-bottom":
                                                  "solid 1px #fff",
                                                display: "flex",
                                                "justify-content":
                                                  "space-between"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    padding: "8px",
                                                    display: "flex",
                                                    "align-items": "center"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        width: "130px",
                                                        "text-align": "center"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _item.goodTypeCodes
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "border-left":
                                                      "1px solid #eee",
                                                    width: "100%",
                                                    "text-align": "center"
                                                  }
                                                },
                                                _vm._l(
                                                  _item.stepwiseDTOS,
                                                  function(res, _index) {
                                                    return _c(
                                                      "div",
                                                      { key: _index },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              padding: "8px"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "LR_center"
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle: {
                                                                      margin:
                                                                        "5px"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        res.stepwise
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle: {
                                                                      color:
                                                                        "#333333",
                                                                      "font-weight":
                                                                        "bold"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _item.currency
                                                                      ) +
                                                                        _vm._s(
                                                                          res.priceInfo
                                                                        )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        !(
                                                          _index ==
                                                          _item.stepwiseDTOS
                                                            .length -
                                                            1
                                                        )
                                                          ? _c("div", {
                                                              staticStyle: {
                                                                height: "1px",
                                                                background:
                                                                  "#eee",
                                                                width: "100%"
                                                              }
                                                            })
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            ]
                                          )
                                        }),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticStyle: {
                                            height: "1px",
                                            background: "#eee",
                                            width: "100%"
                                          }
                                        })
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          slot: "reference",
                                          type: "text"
                                        },
                                        slot: "reference"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("i18n_Price_Details"))
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.fclPriceList.length,
                      expression: "fclPriceList.length"
                    }
                  ],
                  staticClass: "huowuData"
                },
                [
                  _c(
                    "el-container",
                    { staticStyle: { width: "1150px", padding: "0 30px" } },
                    [
                      _c(
                        "el-aside",
                        {
                          staticClass: "aside",
                          staticStyle: { width: "260px" }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { width: "100px", margin: "0" }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { "font-weight": "bold" } },
                                    [_vm._v("拖车报关")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { width: "100px", margin: "0" }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { "font-weight": "bold" } },
                                    [_vm._v("拖柜清关")]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticStyle: {
                                "font-weight": "600",
                                margin: "10px 0"
                              }
                            },
                            [_vm._v("船公司")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c(
                                "el-checkbox-group",
                                {
                                  on: {
                                    change: function($event) {
                                      return _vm.onCheckBoxChange(
                                        $event,
                                        "shipCompanies"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.fclRequestParams.carriers,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.fclRequestParams,
                                        "carriers",
                                        $$v
                                      )
                                    },
                                    expression: "fclRequestParams.carriers"
                                  }
                                },
                                _vm._l(_vm.shipCompanies, function(
                                  item,
                                  index
                                ) {
                                  return _c(
                                    "el-checkbox",
                                    {
                                      key: index,
                                      staticStyle: {
                                        width: "100px",
                                        margin: "2px 0"
                                      },
                                      attrs: {
                                        label: item.code,
                                        disabled: item.disabled
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "font-weight": "bold" }
                                        },
                                        [_vm._v(_vm._s(item.abbr))]
                                      )
                                    ]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticStyle: {
                                "font-weight": "600",
                                margin: "10px 0"
                              }
                            },
                            [_vm._v("班期")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c(
                                "el-checkbox-group",
                                {
                                  on: {
                                    change: function($event) {
                                      return _vm.onCheckBoxChange(
                                        $event,
                                        "weekList"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.fclRequestParams.days,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.fclRequestParams,
                                        "days",
                                        $$v
                                      )
                                    },
                                    expression: "fclRequestParams.days"
                                  }
                                },
                                _vm._l(_vm.weekList, function(item, index) {
                                  return _c(
                                    "el-checkbox",
                                    {
                                      key: index,
                                      staticStyle: {
                                        width: "100px",
                                        margin: "2px 0"
                                      },
                                      attrs: { label: item.value }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "font-weight": "bold" }
                                        },
                                        [_vm._v(_vm._s(item.label))]
                                      )
                                    ]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticStyle: {
                                "font-weight": "600",
                                margin: "10px 0"
                              }
                            },
                            [_vm._v("预计开船")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c(
                                "el-checkbox-group",
                                {
                                  on: {
                                    change: function($event) {
                                      return _vm.onCheckBoxChange(
                                        $event,
                                        "dayList"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.fclRequestParams.etdWeeks,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.fclRequestParams,
                                        "etdWeeks",
                                        $$v
                                      )
                                    },
                                    expression: "fclRequestParams.etdWeeks"
                                  }
                                },
                                _vm._l(_vm.dayList, function(item, index) {
                                  return _c(
                                    "el-checkbox",
                                    {
                                      key: index,
                                      staticStyle: {
                                        width: "100px",
                                        margin: "2px 0"
                                      },
                                      attrs: { label: item.value }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "font-weight": "bold" }
                                        },
                                        [_vm._v(_vm._s(item.label))]
                                      )
                                    ]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-main",
                        {
                          staticClass: "myhover",
                          staticStyle: {
                            width: "100%",
                            padding: "0",
                            overflow: "visible"
                          }
                        },
                        _vm._l(_vm.fclPriceList, function(item, index) {
                          return _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isSelected,
                                  expression: "isSelected"
                                }
                              ],
                              key: index,
                              staticClass: "priceCard",
                              class: _vm.topType
                                ? "animate__animated animate__lightSpeedInRight"
                                : ""
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "cardBody" },
                                [
                                  _c("el-image", {
                                    staticStyle: {
                                      width: "30px",
                                      height: "30px",
                                      "border-radius": "50%"
                                    },
                                    attrs: { fit: "none", url: "" }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "fontStyle" }, [
                                    _vm._v(_vm._s(item.carrier || ""))
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "fontStyle" }, [
                                    _vm._v(_vm._s(item.etd.substring(5) || ""))
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "timeArea" }, [
                                    _c("span", {}, [
                                      _vm._v(
                                        _vm._s(item.tt + " 天 " || "") + " 直达"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticStyle: { color: "#999" } },
                                      [
                                        _vm._v(
                                          "航线 " + _vm._s(item.shipline || "")
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "fontStyle" }, [
                                    _vm._v(_vm._s(item.eta.substring(5) || ""))
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "fontStyle" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(item.cls.substring(5) || "2") +
                                        "\n                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "fontStyle" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(item.returnContainerTerm || "") +
                                        "天\n                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  item.showPrice
                                    ? _c(
                                        "div",
                                        { staticClass: "fontStyle" },
                                        [
                                          _c(
                                            "el-popover",
                                            {
                                              attrs: {
                                                trigger: "hover",
                                                placement: "bottom-end"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "MyscrollbarS" },
                                                [
                                                  item.cntypeOfferPriceDTOS &&
                                                  item.cntypeOfferPriceDTOS
                                                    .length
                                                    ? _c(
                                                        "div",
                                                        [
                                                          _vm._l(
                                                            item.cntypeOfferPriceDTOS,
                                                            function(
                                                              innerItem,
                                                              InnerItemIndex
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key: InnerItemIndex,
                                                                  staticStyle: {
                                                                    "border-bottom":
                                                                      "1px dashed #999",
                                                                    padding:
                                                                      "8px",
                                                                    display:
                                                                      "flex",
                                                                    "justify-content":
                                                                      "space-between"
                                                                  }
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        innerItem.cntypeCode ||
                                                                          "暂无"
                                                                      )
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          innerItem.currency ||
                                                                            ""
                                                                        ) +
                                                                        "\n                            "
                                                                    ),
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          innerItem.price ||
                                                                            ""
                                                                        )
                                                                      )
                                                                    ])
                                                                  ])
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c("div", {
                                                            staticStyle: {
                                                              height: "20px"
                                                            }
                                                          })
                                                        ],
                                                        2
                                                      )
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            "text-align":
                                                              "center"
                                                          }
                                                        },
                                                        [_vm._v("暂无内容")]
                                                      )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "reference" },
                                                  slot: "reference"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "fontStyle",
                                                      staticStyle: {
                                                        color: "red",
                                                        "border-bottom":
                                                          "1px dashed #999",
                                                        "font-size": "17px"
                                                      }
                                                    },
                                                    [_vm._v("$1150")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-size": "12px",
                                                        height: "0"
                                                      }
                                                    },
                                                    [_vm._v("起")]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.showPrice
                                    ? _c(
                                        "div",
                                        { staticClass: "fontStyle" },
                                        [
                                          _c(
                                            "el-popover",
                                            {
                                              attrs: {
                                                trigger: "hover",
                                                placement: "bottom-end"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "MyscrollbarS",
                                                  staticStyle: {
                                                    height: "500px",
                                                    width: "400px"
                                                  }
                                                },
                                                [
                                                  item.additionalChargeDTOList &&
                                                  item.additionalChargeDTOList
                                                    .length
                                                    ? _c(
                                                        "div",
                                                        [
                                                          _vm._l(
                                                            item.additionalChargeDTOList,
                                                            function(
                                                              innerItem,
                                                              InnerItemIndex
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key: InnerItemIndex,
                                                                  staticStyle: {
                                                                    border:
                                                                      "solid 1px #eee",
                                                                    "border-bottom":
                                                                      "solid 1px #fff",
                                                                    display:
                                                                      "flex",
                                                                    "justify-content":
                                                                      "space-between"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticStyle: {
                                                                        padding:
                                                                          "8px",
                                                                        display:
                                                                          "flex",
                                                                        "align-items":
                                                                          "center"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticStyle: {
                                                                            width:
                                                                              "130px",
                                                                            "text-align":
                                                                              "center"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              innerItem.feeName ||
                                                                                "暂无"
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticStyle: {
                                                                        "border-left":
                                                                          "1px solid #eee",
                                                                        width:
                                                                          "100%",
                                                                        "text-align":
                                                                          "center"
                                                                      }
                                                                    },
                                                                    _vm._l(
                                                                      innerItem.cntypeChargeDTOList,
                                                                      function(
                                                                        SecinnerItem,
                                                                        SecInnerItemIndex
                                                                      ) {
                                                                        return _c(
                                                                          "div",
                                                                          {
                                                                            key: SecInnerItemIndex
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticStyle: {
                                                                                  padding:
                                                                                    "8px"
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  [
                                                                                    _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticStyle: {
                                                                                          margin:
                                                                                            "5px"
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "\n                                    " +
                                                                                            _vm._s(
                                                                                              SecinnerItem.cntypeCode ||
                                                                                                "暂无"
                                                                                            )
                                                                                        )
                                                                                      ]
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "span",
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            SecinnerItem.priceDesc ||
                                                                                              ""
                                                                                          )
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            !(
                                                                              SecInnerItemIndex ==
                                                                              innerItem
                                                                                .cntypeChargeDTOList
                                                                                .length -
                                                                                1
                                                                            )
                                                                              ? _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticStyle: {
                                                                                      height:
                                                                                        "1px",
                                                                                      background:
                                                                                        "#eee",
                                                                                      width:
                                                                                        "100%"
                                                                                    }
                                                                                  }
                                                                                )
                                                                              : _vm._e()
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c("div", {
                                                            staticStyle: {
                                                              height: "1px",
                                                              background:
                                                                "#eee",
                                                              width: "100%"
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c("div", {
                                                            staticStyle: {
                                                              height: "20px"
                                                            }
                                                          })
                                                        ],
                                                        2
                                                      )
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            "text-align":
                                                              "center"
                                                          }
                                                        },
                                                        [_vm._v("暂无内容")]
                                                      )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "reference" },
                                                  slot: "reference"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "fontStyle",
                                                      staticStyle: {
                                                        color: "red",
                                                        "border-bottom":
                                                          "1px dashed #999",
                                                        "font-size": "17px"
                                                      }
                                                    },
                                                    [_vm._v("$1150")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-size": "12px",
                                                        height: "0"
                                                      }
                                                    },
                                                    [_vm._v("起")]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !item.showPrice
                                    ? _c("div", { staticClass: "fontStyle" }, [
                                        _vm._v("登录后显示")
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !item.showPrice
                                    ? _c("div", { staticClass: "fontStyle" }, [
                                        _vm._v("登录后显示")
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary", size: "mini" }
                                    },
                                    [_vm._v("去订舱")]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.avtive == 1,
                  expression: "avtive == 1"
                }
              ],
              staticClass: "GuessWrap OrderDetails"
            },
            [
              _vm.activities.length == 0 &&
              _vm.topType &&
              !_vm.trackTableData.length
                ? _c("el-alert", {
                    attrs: {
                      closable: false,
                      title: _vm.$t("i18n_no_tracking_status_yet"),
                      type: "info",
                      description: _vm.$t("i18n_no_track"),
                      "show-icon": ""
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.activities.length != 0
                ? _c(
                    "div",
                    [
                      _vm.activities[0].fbxBoxTrailDTOList
                        ? _c(
                            "el-collapse",
                            { staticClass: "track-collapse" },
                            _vm._l(_vm.activities, function(item, index) {
                              return _c(
                                "el-collapse-item",
                                { key: index },
                                [
                                  _c("template", { slot: "title" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "LR_center",
                                        staticStyle: { width: "100%" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              flex: "1",
                                              "min-width": "0",
                                              display: "flex"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "flex-shrink": "0",
                                                  "padding-left": "15px",
                                                  "padding-right": "15px"
                                                }
                                              },
                                              [_vm._v(_vm._s(item.commonNos))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "min-width": "0"
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "font-weight": "bold"
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(item.name))]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "padding-left": "15px",
                                                      "font-weight": "bold"
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(item.namee))]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "padding-left": "15px",
                                                      color: "#999"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.occurrenceDate
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "padding-left": "5px",
                                                      color: "#999"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.occurrenceTime
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "flex-shrink": "0",
                                              "white-space": "nowrap",
                                              "margin-left": "10px",
                                              color: "#67c23a"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "i18n_more_tracking_status"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-timeline",
                                    { staticStyle: { padding: "0 30px" } },
                                    _vm._l(item.fbxBoxTrailDTOList, function(
                                      activity,
                                      _index
                                    ) {
                                      return _c(
                                        "el-timeline-item",
                                        {
                                          key: _index,
                                          attrs: {
                                            type: "primary",
                                            color: activity.color
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                width: "100%",
                                                float: "left",
                                                "margin-bottom": "5px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    activity.occurrenceDate
                                                  )
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "5px"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      activity.occurrenceTime
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                color: "#999",
                                                "font-size": "11px",
                                                display: "block"
                                              }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(_vm._s(activity.name))
                                              ]),
                                              _vm._v(" "),
                                              activity.desc
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "10px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "(" +
                                                          _vm._s(
                                                            activity.desc
                                                          ) +
                                                          ")"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(_vm._s(activity.namee))
                                              ]),
                                              _vm._v(" "),
                                              activity.apptWarehouseOrderId
                                                ? _c(
                                                    "el-button",
                                                    {
                                                      attrs: { type: "text" },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.GetshowText(
                                                            activity
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "i18n_Inquiry_receipt"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                2
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.activities[0].fbxBoxTrailDTOList
                        ? _c(
                            "div",
                            { staticStyle: { width: "100%", float: "left" } },
                            [
                              _c(
                                "el-card",
                                { staticClass: "box-card" },
                                _vm._l(_vm.activities, function(item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "text item",
                                      staticStyle: {
                                        width: "100%",
                                        float: "left",
                                        "margin-bottom": "15px"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticStyle: { float: "left" } },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "padding-left": "15px",
                                                color: "#999"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(item.occurrenceDate) +
                                                  "\n                  "
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "10px"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.occurrenceTime)
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticStyle: { float: "left" } },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "padding-left": "15px",
                                                "font-weight": "bold"
                                              }
                                            },
                                            [_vm._v(_vm._s(item.name))]
                                          ),
                                          _vm._v(" "),
                                          item.desc
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "10px"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "(" +
                                                      _vm._s(item.desc) +
                                                      ")"
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "margin-left": "20px"
                                              }
                                            },
                                            [_vm._v(_vm._s(item.namee))]
                                          ),
                                          _vm._v(" "),
                                          item.apptWarehouseOrderId
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color: "#5ab53c",
                                                    cursor: "pointer"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.GetshowText(
                                                        item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "i18n_Inquiry_receipt"
                                                        )
                                                      )
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.trackTableData.length && _vm.trackType === 3
                ? _c(
                    "div",
                    [
                      _c(
                        "el-table",
                        {
                          staticClass: "trackTable",
                          staticStyle: { width: "961px" },
                          attrs: {
                            border: "",
                            data: _vm.trackTableData,
                            "tooltip-effect": "dark",
                            "header-cell-style": { background: "#F3F3F3" }
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("i18n_Order_Status"),
                              prop: "orderStatus",
                              width: "120px",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("i18n_warehouse_status"),
                              prop: "JCStatus",
                              width: "120px",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("i18n_Booking_status"),
                              prop: "PGStatus",
                              width: "120px",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("i18n_Shipping_Schedule_Status"),
                              prop: "DGStatus",
                              width: "120px",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("i18n_Trunk_status"),
                              prop: "GXStatus",
                              width: "120px",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("i18n_Customs_clearance_status"),
                              prop: "QGStatus",
                              width: "120px",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("i18n_Distribution_Center_Status"),
                              prop: "FBZXStatus",
                              width: "120px",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("i18n_delivery_status"),
                              prop: "PSStatus",
                              width: "120px",
                              align: "center"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.trackTableData.length && _vm.trackType === 2
                ? _c(
                    "div",
                    [
                      _c(
                        "el-table",
                        {
                          staticClass: "trackTable",
                          attrs: {
                            border: "",
                            data: _vm.trackTableData,
                            "tooltip-effect": "dark",
                            "header-cell-style": { background: "#F3F3F3" }
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("i18n_Order_Status"),
                              prop: "orderStatus",
                              width: "120px",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("i18n_Pickup_Status"),
                              prop: "THStatus",
                              width: "120px",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("i18n_warehouse_status"),
                              prop: "JCStatus",
                              width: "120px",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("i18n_Booking_Status"),
                              prop: "PGStatus",
                              width: "120px",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("i18n_China_Hong_Kong_Status"),
                              prop: "DGStatus",
                              width: "120px",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("i18n_Trunk_status"),
                              prop: "GXStatus",
                              width: "120px",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("i18n_Customs_clearance_status"),
                              prop: "QGStatus",
                              width: "120px",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("i18n_Distribution_Center_Status"),
                              prop: "FBZXStatus",
                              width: "120px",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("i18n_delivery_status"),
                              prop: "PSStatus",
                              width: "120px",
                              align: "center"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("loginType", { ref: "child" }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("i18n_Shipping_Instructions"),
            visible: _vm.dialogTableVisible
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogTableVisible = $event
            }
          }
        },
        [
          _c("div", {
            staticClass: "showText",
            domProps: { innerHTML: _vm._s(_vm.sendgoodsremarks) }
          })
        ]
      ),
      _vm._v(" "),
      _vm.showMydialog
        ? _c(
            "div",
            {
              staticClass: "dialogCover",
              on: {
                click: function($event) {
                  if ($event.target !== $event.currentTarget) {
                    return null
                  }
                  return _vm.closeMyDialog()
                }
              }
            },
            [
              _c("div", { staticClass: "myDialog" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between"
                    }
                  },
                  [
                    _c("span", { staticStyle: { "font-weight": "600" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.getLIstType === "PS" ? "派送地址" : "提货地址"
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "el-icon-close",
                      staticStyle: { cursor: "pointer" },
                      on: {
                        click: function($event) {
                          return _vm.closeMyDialog()
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                          margin: "20px 0"
                        }
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "el-input",
                              {
                                staticStyle: { width: "250px" },
                                attrs: {
                                  clearable: "",
                                  placeholder: "请输入姓名或电话",
                                  size: "medium"
                                },
                                on: {
                                  clear: function($event) {
                                    return _vm.getPeopletable()
                                  }
                                },
                                nativeOn: {
                                  keyup: function($event) {
                                    return _vm.searchNameOrPhone($event)
                                  }
                                },
                                model: {
                                  value: _vm.nameOrPhone,
                                  callback: function($$v) {
                                    _vm.nameOrPhone = $$v
                                  },
                                  expression: "nameOrPhone"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-input__icon el-icon-search",
                                  attrs: { slot: "prefix" },
                                  slot: "prefix"
                                }),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { slot: "append", type: "primary" },
                                    slot: "append"
                                  },
                                  [_vm._v("搜索")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "medium",
                              plain: "",
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.showAdd(true)
                              }
                            }
                          },
                          [_vm._v("新增地址")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.edit
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "background-color": "#fff",
                              "border-radius": "20px",
                              padding: "20px",
                              "box-shadow":
                                "0px 0px 20px 0px rgba(193, 193, 193, 0.31)"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "85%",
                                  margin: "0 auto",
                                  "max-width": "500px"
                                }
                              },
                              [
                                _c(
                                  "el-row",
                                  {
                                    staticStyle: {
                                      "margin-bottom": "8px",
                                      "margin-left": "1px",
                                      display: "flex"
                                    },
                                    attrs: { gutter: 20 }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "grid-content",
                                            staticStyle: {
                                              "margin-right": "35px",
                                              "min-width": "50px"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "line-height": "40px"
                                                }
                                              },
                                              [_vm._v("联系人")]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "grid-content" },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "请输入联系人"
                                              },
                                              model: {
                                                value: _vm.submitForm.name,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.submitForm,
                                                    "name",
                                                    $$v
                                                  )
                                                },
                                                expression: "submitForm.name"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "grid-content",
                                            staticStyle: {
                                              "margin-left": "10px",
                                              "margin-right": "10px",
                                              "min-width": "60px"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "line-height": "40px"
                                                }
                                              },
                                              [_vm._v("联系方式")]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "grid-content" },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "请输入联系方式"
                                              },
                                              model: {
                                                value: _vm.submitForm.tel,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.submitForm,
                                                    "tel",
                                                    $$v
                                                  )
                                                },
                                                expression: "submitForm.tel"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  {
                                    staticStyle: { "margin-bottom": "8px" },
                                    attrs: { gutter: 20 }
                                  },
                                  [
                                    _c("el-col", { attrs: { span: 4 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "grid-content" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "line-height": "40px"
                                              }
                                            },
                                            [_vm._v("联系地址")]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("el-col", { attrs: { span: 18 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "grid-content" },
                                        [
                                          _vm.getLIstType == "PS"
                                            ? _c("el-cascader", {
                                                attrs: {
                                                  options: _vm.jackPsCitylist,
                                                  placeholder: "请选择派送地址",
                                                  clearable: "",
                                                  props: _vm.props
                                                },
                                                on: {
                                                  change: _vm.handleChange
                                                },
                                                model: {
                                                  value: _vm.value,
                                                  callback: function($$v) {
                                                    _vm.value = $$v
                                                  },
                                                  expression: "value"
                                                }
                                              })
                                            : _c("el-cascader", {
                                                attrs: {
                                                  options: _vm.jackCitylist,
                                                  placeholder: "请选择提货地址",
                                                  clearable: "",
                                                  props: _vm.props
                                                },
                                                on: {
                                                  change: _vm.handleChange
                                                },
                                                model: {
                                                  value: _vm.value,
                                                  callback: function($$v) {
                                                    _vm.value = $$v
                                                  },
                                                  expression: "value"
                                                }
                                              })
                                        ],
                                        1
                                      )
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  {
                                    staticStyle: { "margin-bottom": "8px" },
                                    attrs: { gutter: 20 }
                                  },
                                  [
                                    _c("el-col", { attrs: { span: 4 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "grid-content" },
                                        [
                                          _c("div", {
                                            staticStyle: {
                                              "line-height": "40px",
                                              width: "10px",
                                              height: "10px"
                                            }
                                          })
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("el-col", { attrs: { span: 18 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "grid-content" },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              type: "textarea",
                                              rows: "2",
                                              placeholder: "请输入详细地址"
                                            },
                                            model: {
                                              value: _vm.submitForm.address,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.submitForm,
                                                  "address",
                                                  $$v
                                                )
                                              },
                                              expression: "submitForm.address"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  {
                                    staticStyle: { "margin-bottom": "8px" },
                                    attrs: { gutter: 20 }
                                  },
                                  [
                                    _c("el-col", { attrs: { span: 4 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "grid-content" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "line-height": "40px"
                                              }
                                            },
                                            [_vm._v("标签")]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("el-col", { attrs: { span: 18 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "grid-content" },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              placeholder: "请输入标签"
                                            },
                                            model: {
                                              value: _vm.submitForm.tag,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.submitForm,
                                                  "tag",
                                                  $$v
                                                )
                                              },
                                              expression: "submitForm.tag"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "330px",
                                      margin: "0 auto",
                                      "text-align": "center"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c("el-checkbox", {
                                          staticStyle: {
                                            "margin-right": "10px"
                                          },
                                          attrs: { "text-color": "#5AB53C" },
                                          model: {
                                            value: _vm.submitForm.isdefault,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.submitForm,
                                                "isdefault",
                                                $$v
                                              )
                                            },
                                            expression: "submitForm.isdefault"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              display: "block",
                                              "margin-bottom": "8px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  设置为默认地址\n                "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: {
                                          background: "#5ab53c",
                                          border: "1px solid #5ab53c",
                                          "border-radius": "5px",
                                          color: "#fff"
                                        },
                                        on: { click: _vm.addAddr }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            this.submitForm.id ? "修改" : "新增"
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "info" },
                                        on: {
                                          click: function($event) {
                                            return _vm.showAdd(false)
                                          }
                                        }
                                      },
                                      [_vm._v("关闭")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.edit
                      ? _c(
                          "el-table",
                          {
                            ref: "Table",
                            staticStyle: { width: "100%", overflow: "hidden" },
                            attrs: {
                              size: "mini",
                              height: "300",
                              "tooltip-effect": "dark",
                              data: _vm.tableData,
                              "max-height": "200",
                              "highlight-current-row": "",
                              border: ""
                            },
                            on: { "row-click": _vm.rowClick }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                label: "姓名",
                                width: "100",
                                align: "center",
                                prop: "name"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "电话",
                                width: "120",
                                align: "center",
                                prop: "tel"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "联系地址",
                                "show-overflow-tooltip": "",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(scope.row.parvince) +
                                            "\n              " +
                                            _vm._s(scope.row.country) +
                                            "\n              " +
                                            _vm._s(scope.row.city) +
                                            "\n              " +
                                            _vm._s(scope.row.area) +
                                            "\n              " +
                                            _vm._s(scope.row.address) +
                                            "\n            "
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                483136935
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "操作",
                                align: "center",
                                width: "160"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              size: "mini"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.setDefault(scope.row)
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                style: scope.row.isdefault
                                                  ? "color:#604AFF"
                                                  : "color:#9A9A9A"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.isdefault
                                                      ? "默认"
                                                      : "设为默认"
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "text"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.handleEdit(
                                                  scope.$index,
                                                  scope.row
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("编辑")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              size: "mini"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.handleDelete(
                                                  scope.$index,
                                                  scope.row
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("删除")]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2186430193
                              )
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.edit
                      ? _c("el-alert", {
                          staticStyle: { "margin-top": "20px" },
                          attrs: {
                            title: "点击任意一行选择您的地址",
                            type: "info",
                            center: "",
                            "show-icon": ""
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticStyle: { "padding-left": "100px" },
          attrs: {
            title: "查看回执",
            visible: _vm.dialogVisible,
            width:
              (_vm.imagesList.length
                ? _vm.imagesList.length > 3
                  ? 660
                  : _vm.imagesList.length * 220
                : 660) + "px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: { display: "flex", "flex-wrap": "wrap", gap: "10px" }
            },
            _vm._l(_vm.imagesList, function(item, index) {
              return _c("el-image", {
                key: index,
                staticStyle: { width: "200px" },
                attrs: {
                  src: item,
                  "preview-src-list": _vm.imagesList,
                  fit: "contain"
                }
              })
            }),
            1
          ),
          _vm._v(" "),
          _vm.fileList.length
            ? _c(
                "el-table",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { data: _vm.fileList, border: "" }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "文件名", prop: "name" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-link",
                                {
                                  attrs: { underline: false, type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.fileDownload(scope.row.src)
                                    }
                                  }
                                },
                                [_vm._v("下载")]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      127950771
                    )
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.imagesList && !_vm.fileList.length
            ? _c("el-alert", {
                attrs: {
                  title: "未上传回执",
                  type: "info",
                  center: "",
                  "show-icon": ""
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.topType
        ? _c(
            "div",
            { staticClass: "clickPointer" },
            [
              false
                ? [
                    _c(
                      "div",
                      {
                        staticClass: "click_pointer_con",
                        attrs: { title: "www.19jiuyu.com" },
                        on: { click: _vm.goJiuYu }
                      },
                      [
                        _vm._m(4),
                        _vm._v(" "),
                        _vm._m(5),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "dragon_img",
                          attrs: {
                            src: require("../../assets/images/jiuDragon.png"),
                            alt: ""
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "click_pointer",
                          attrs: {
                            src: require("../../assets/images/pointer.png"),
                            alt: ""
                          }
                        })
                      ]
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "click_pointer_con",
                  on: { click: _vm.goFybZbx }
                },
                [
                  _c("img", {
                    staticClass: "fyb_zbx_img",
                    attrs: {
                      src: require("../../assets/images/fyb_zbx.gif"),
                      alt: ""
                    }
                  })
                ]
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.topType,
              expression: "!topType"
            }
          ],
          staticStyle: {
            "text-align": "center",
            "margin-bottom": "20px",
            position: "absolute",
            width: "100%",
            bottom: "10px",
            color: "#ffffff"
          }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.$t("i18n_cititrans")) + "\n    "),
          _c(
            "a",
            {
              staticStyle: { color: "#ffffff" },
              attrs: { href: "https://beian.miit.gov.cn/", target: "_blank" }
            },
            [_vm._v("粤ICP备18003296号")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "selectIcon2",
        staticStyle: { top: "12px", "font-size": "28px" }
      },
      [_c("i", { staticClass: "el-icon-map-location" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "selectIcon2",
        staticStyle: { top: "12px", "font-size": "28px" }
      },
      [_c("i", { staticClass: "el-icon-s-home" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "selectIcon2",
        staticStyle: { top: "12px", "font-size": "28px" }
      },
      [_c("i", { staticClass: "el-icon-map-location" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "selectIcon2",
        staticStyle: { top: "12px", "font-size": "28px" }
      },
      [_c("i", { staticClass: "el-icon-map-location" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "click_pointer_up" }, [
      _c("div", { staticClass: "click_up_content" }, [
        _vm._v("\n            走美国FBA海运 , 享账期结算权益\n          ")
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "bottom_icon",
        attrs: { src: require("../../assets/images/jiuSign.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "click_pointer_down" }, [
      _c("div", { staticClass: "click_down_left" }, [
        _vm._v("亦邦旗下-全球到门快运网")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "click_down_right" }, [
        _vm._v("www.19jiuyu.com")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1564b99a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1564b99a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/placeOrder/placeIndex.vue
// module id = null
// module chunks = 